<div class="section-title">Project Expenses</div>
<p class="section-caption">All projects are listed. Amounts cover all submitted expense history by default; projects without expenses show zero.</p>

<div class="project-searchbar" role="search">
  <svg width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m16 16 5 5"></path></svg>
  <input id="project-search" type="search" maxlength="100" [(ngModel)]="search" (ngModelChange)="onSearchChange()" placeholder="Search projects" aria-label="Search projects" />
  <button type="button" aria-label="Open project filters" [attr.aria-expanded]="filterOpen" (click)="openFilters()">
    <svg width="25" height="25" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M3 5h18M3 12h18M3 19h18"></path><path d="M8 2v6M16 9v6M10 16v6"></path></svg>
  </button>
</div>

<div class="project-filter-backdrop" *ngIf="filterOpen" (click)="filterOpen = false">
  <section class="project-filter-dialog" role="dialog" aria-modal="true" aria-label="Project expense filters" (click)="$event.stopPropagation()">
    <div class="project-filter-header"><h2>Filter projects</h2><button type="button" aria-label="Close filters" (click)="filterOpen = false">&times;</button></div>
    <div class="project-filter-fields">
      <label for="project-from-month">From month<input id="project-from-month" type="month" [(ngModel)]="draftStartMonth" /></label>
      <label for="project-to-month">To month<input id="project-to-month" type="month" [(ngModel)]="draftEndMonth" /></label>
    </div>
    <p>Projects with expense status</p>
    <div class="project-status-options">
      <label><input type="radio" name="project-status" value="all" [(ngModel)]="draftStatus" /> All</label>
      <label><input type="radio" name="project-status" value="pending" [(ngModel)]="draftStatus" /> Pending</label>
      <label><input type="radio" name="project-status" value="rejected" [(ngModel)]="draftStatus" /> Rejected</label>
      <label><input type="radio" name="project-status" value="approved" [(ngModel)]="draftStatus" /> Approved</label>
    </div>
    <p *ngIf="draftStartMonth && draftEndMonth && draftStartMonth > draftEndMonth" role="alert">From month must not be after To month.</p>
    <div class="project-filter-actions">
      <button type="button" (click)="clearFilters()">Clear filters</button>
      <button type="button" class="primary" [disabled]="draftStartMonth && draftEndMonth && draftStartMonth > draftEndMonth" (click)="applyDraftFilters()">Apply</button>
    </div>
  </section>
</div>

<p *ngIf="invalidRange" role="alert">From month must not be after To month.</p>
<p *ngIf="loading" role="status">Loading project expenses...</p>
<p *ngIf="error" role="alert">{{ error }} <button type="button" (click)="retry()">Retry</button></p>

<ng-container *ngIf="data">
  <p *ngIf="data.totalProjects === 0">No projects match these filters.</p>
  <div *ngIf="data.results.length" class="table-container project-expense-table" role="region" aria-label="Project expense totals" tabindex="0">
    <table>
      <thead><tr><th>Project</th><th>Company code</th><th>WBS</th><th>Submitted</th><th>Pending</th><th>Rejected</th><th>Approved</th></tr></thead>
      <tbody><tr *ngFor="let row of data.results">
        <td>{{ row.projectName }}<span *ngIf="row.projectCode"> ({{ row.projectCode }})</span></td>
         <td>{{ row.companyCode || '—' }}</td><td>{{ row.wbsExternal || '—' }}</td>
        <td>{{ row.submittedAmount | number:'1.2-2' }}</td><td>{{ row.pendingAmount | number:'1.2-2' }}</td>
        <td>{{ row.rejectedAmount | number:'1.2-2' }}</td><td>{{ row.approvedAmount | number:'1.2-2' }}</td>
      </tr></tbody>
    </table>
  </div>
  <div *ngIf="data.totalProjects" class="project-pages">
    <span role="status">Showing {{ (data.page - 1) * data.pageSize + 1 }}–{{ (data.page - 1) * data.pageSize + data.results.length }} of {{ data.totalProjects }} projects</span>
    <nav aria-label="Project expense pages">
      <label for="project-page-size">Rows per page</label>
      <select id="project-page-size" [(ngModel)]="pageSize" (ngModelChange)="changePageSize()"><option [ngValue]="25">25</option><option [ngValue]="50">50</option><option [ngValue]="100">100</option></select>
      <button type="button" [disabled]="data.page <= 1" (click)="goToPage(1)">First</button>
      <button type="button" [disabled]="data.page <= 1" (click)="goToPage(data.page - 1)">Previous</button>
      <span>Page {{ data.page }} of {{ data.totalPages }}</span>
      <input type="number" min="1" [max]="data.totalPages" [(ngModel)]="pageInput" aria-label="Page number" (keyup.enter)="jumpToPage()" />
      <button type="button" (click)="jumpToPage()">Go</button>
      <button type="button" [disabled]="data.page >= data.totalPages" (click)="goToPage(data.page + 1)">Next</button>
      <button type="button" [disabled]="data.page >= data.totalPages" (click)="goToPage(data.totalPages)">Last</button>
    </nav>
  </div>
</ng-container>
